import { Box } from "@mui/material";
import { Embed } from "features/common/components/Embed";
import { useReportPreview } from "./useReportPreview";
import { Card } from "features/common/components/Card";
import { CardActionButton } from "features/common/components/CardTable";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { Spinner } from "features/common/components/Spinner";
import { AlertMessage } from "features/common/components/AlertMessage";
import { useMemo } from "react";

interface ReportPreviewProps {
  action: "RECONCILIATION" | "STATISTICS";
}

export const ReportPreview = ({ action }: ReportPreviewProps) => {
  const {
    reportUrl,
    handleDownloadReport,
    handleBack,
    isFetchingReport,
    reportError,
    downloadIsAllowed,
  } = useReportPreview({ action });

  const renderPdf = useMemo(
    () => () =>
      (
        <Box sx={{ minHeight: "500px" }}>
          <AlertMessage
            message={reportError}
            show={!!reportError}
            severity="error"
            isPermanent
          />
          {isFetchingReport && <Spinner height="100%" />}
          {reportUrl && <Embed src={reportUrl} />}
        </Box>
      ),
    [isFetchingReport, reportError, reportUrl]
  );

  return (
    <>
      <Card
        title="Report Overview"
        style={{ width: "1512px" }}
        actions={
          <Box>
            <CardActionButton
              variant="outlined"
              color="primary"
              onClick={handleDownloadReport}
              style={{ marginRight: 10 }}
              endIcon={<DownloadOutlinedIcon />}
              children="Download PDF"
              disabled={!!reportError || !downloadIsAllowed}
            />
            <CardActionButton
              variant="outlined"
              color="secondary"
              startIcon={<ArrowBackOutlinedIcon />}
              sx={{ textTransform: "none" }}
              onClick={handleBack}
              children="Back"
            />
          </Box>
        }
        Component={renderPdf}
      />
    </>
  );
};
